<template>
  <div
      class="calendar_popup"
      :class="`${arrow}_arrow`"
      :style="{left, top}"
  >
    <div class="title">
      <span>{{ chosenRole }}</span>
      <button v-if="isEdit" class="close" @click="$emit('delete')">
        <img src="../../assets/images/icons/trash.svg" alt="">
      </button>
    </div>

    <div class="desc_text">{{ coworking.name }}</div>
    <div class="desc_text">{{ date }}</div>
    <div class="timepicker_wrap">
      <input
          type="time"
          :value="startTime"
          step="1800"
          @input="e => $emit('changeStartTime', e.target.value)"
      >
      <span>—</span>
      <input
          type="time"
          :value="endTime"
          step="1800"
          @input="e => $emit('changeEndTime', e.target.value)"
      >
    </div>
    <div class="buttons_group">
      <button class="save_btn cancel" @click="$emit(isEdit ? 'cancel' : 'delete')">Отменить</button>
      <button class="save_btn" @click="$emit('submit')">Сохранить</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Calendar_Create_Small_Popup',
  props: [
    'left',
    'top',
    'arrow',
    'startTime',
    'endTime',
    'chosenRole',
    'isEdit',
    'id',
    'coworking',
    'startAt'
  ],
  computed: {
    date() {
      return this.startAt ? this.$moment(this.startAt).locale('ru').format('ddd DD, MMMM') : null;
    }
  },
}
</script>

<style scoped lang="scss">
.calendar_popup {
  width: 268px;
  z-index: 3 !important;

  .desc_text:first-child {
    margin-bottom: 5px;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: -30px;
  }

  .close {
    border: none;
    background-color: transparent;
  }
}

.save_btn:disabled {
  opacity: .7;
  cursor: auto;
}

</style>
